const validCrmIdPattern = /^\d+$/;

export const getPresalesToolRedirectUrl = (
  bookingType: string | null,
  crmId: string,
  httpStatusCode: number | undefined,
  presalesToolBaseUrl: string | undefined,
): string | undefined => {
  const trimmedCrmId = crmId.trim();
  if (
    bookingType !== 'autodialerhp'
    || httpStatusCode !== 403
    || !validCrmIdPattern.test(trimmedCrmId)
    || !presalesToolBaseUrl
  ) {
    return undefined;
  }

  try {
    const redirectUrl = new URL(presalesToolBaseUrl);
    const basePath = redirectUrl.pathname.replace(/\/+$/, '');
    redirectUrl.pathname = `${basePath}/form`;
    redirectUrl.searchParams.set('dealId', trimmedCrmId);
    return redirectUrl.toString();
  } catch {
    return undefined;
  }
};

export const redirectUnauthorizedAutodialerHpToPresalesTool = (
  bookingType: string | null,
  crmId: string,
  httpStatusCode: number | undefined,
  presalesToolBaseUrl: string | undefined,
  replaceLocation: (url: string) => void = (url) => window.location.replace(url),
): boolean => {
  const redirectUrl = getPresalesToolRedirectUrl(bookingType, crmId, httpStatusCode, presalesToolBaseUrl);
  if (!redirectUrl) {
    return false;
  }

  replaceLocation(redirectUrl);
  return true;
};
